import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { BUY_AGAIN_ICONS, LINK_BUY_AGAIN } from '../../config/links/links';
import { BRAND_LIVINGSOCIAL } from '../../config/setup/setup';
import { BUY_AGAIN_DEALS_FLAG } from '../../config/text/text';
import { trackEvent } from '../../helpers/analytics';
import { redirectToURL } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';

const HeaderBuyAgain = ({ brand = null, countryCode = null }) => {
  const router = useRouter();
  const theme = useContext(ThemeContext);
  const isLoggedIn = useSelector((state) => state.user.isAuthenticated);

  if (!isLoggedIn || localStorage.getItem(BUY_AGAIN_DEALS_FLAG) !== 'true')
    return null;

  const onClickIcon = () => {
    trackEvent('buy_again_click_header');
    redirectToURL(LINK_BUY_AGAIN, router);
  };

  const getIconImage = () => {
    return brand === BRAND_LIVINGSOCIAL
      ? countryCode === 'ie'
        ? BUY_AGAIN_ICONS.livingsocialie
        : BUY_AGAIN_ICONS.livingsocial
      : countryCode === 'ie'
      ? BUY_AGAIN_ICONS.wowcherie
      : BUY_AGAIN_ICONS.wowcher;
  };

  return (
    <>
      <div className="buy-again-icon" onClick={onClickIcon}>
        <img alt="" className="icon-image" src={getIconImage()} />
        <div className="icon__tooltip">Buy Again</div>
      </div>

      <style jsx>{`
        .buy-again-icon {
          position: relative;
          display: inline-block;
          margin-right: 10px;
        }

        .icon-image {
          cursor: pointer;
          width: 32px;
          height: 32px;
        }

        .icon__tooltip {
          color: ${theme.colors.headerprimary};
          display: none;
          font-size: 12px;
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
        }

        .buy-again-icon:hover .icon__tooltip {
          display: block;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .icon__tooltip {
            display: none !important;
          }
          .icon-image {
            width: 24px;
            height: 24px;
          }
        }
      `}</style>
    </>
  );
};

HeaderBuyAgain.propTypes = {
  brand: PropTypes.string,
  countryCode: PropTypes.string,
};

HeaderBuyAgain.defaultProps = {
  brand: null,
  countryCode: null,
};

export default HeaderBuyAgain;
